<mat-expansion-panel
	[togglePosition]="'before'"
	[expanded]="false"
	class="export-action-panel level-2 pl-4"
	*ngIf="subgroup.items?.[0] as firstItem"
>
	<mat-expansion-panel-header>
		<div class="mt-1 action-details level-2">
			<div class="export-title level-2">
				<mat-icon
					*localVar="subgroup.items | transformObject : ExportDownloadUtils.findItemByStatus : TaskStatus.Failed as isFailed"
					class="status-icon"
					[ngClass]="{ success: !isFailed, failure: isFailed }"
				>
					{{ isFailed ? 'clear' : 'check' }}
				</mat-icon>

				<span class="name">
					{{ subgroup.name | getLocale: subgroup.locale?.group?.name }}
				</span>
				<span
					class="sizes"
					i18n="Export Sizes Count@@exportDownloadSizesCount"
					*ngIf="subgroup.items.length as sizes"
				>({{ sizes }} {sizes, plural, =1 {size} other {sizes}})</span>
				<div>
					<mat-chip-list class="items-tags">
						<mat-chip
							*ngFor="let format of (subgroup.items | transformObject : ExportDownloadUtils.getGroupFormats)"
							class="tag-item"
						>
							<span>{{ EXPORT_TYPE_LABELS[format] | titlecase }}</span>
						</mat-chip>
					</mat-chip-list>
				</div>
			</div>
			<button
				color="primary"
				class="download-button"
				(click)="$event.stopImmediatePropagation();
					firstItem.type === CartItemType.VIDEO
						? downloadItem.emit({ cartItem: firstItem })
						: downloadByGroupId.emit(firstItem)"
			>
				<mat-icon inline>download</mat-icon>
			</button>
		</div>
	</mat-expansion-panel-header>
	<div class="export-destination-details no-border">
		<app-export-download-item-row
			class="action-details"
			*ngFor="let item of (subgroup.items | arrayOrDefault)"
			[item]="item"
			(retryTasks)="retryTasks.emit()"
			(downloadItem)="downloadItem.emit($event)"
		></app-export-download-item-row>
	</div>
</mat-expansion-panel>
